import 'babel-polyfill'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import './bla.css'
import Vue from 'vue'

const perPage = 50;

wp.api.loadPromise.done(async () => {

    Vue.mixin({
        filters: {
            date (timestamp) {
                let d = new Date(timestamp)
                return d.toLocaleDateString()
            },
            datetime (timestamp) {
                let d = new Date(timestamp)
                return d.toLocaleString()
            },
        },
    })

    new Vue({
        components: { flatPickr },
        data () {
            return {
                collection: null,
                items: [],
                params: {},
                loading: true,
                pagination: {
                  page: 1,
                  totalPages: 0,
                  totalObjects: 0,
                },
                fpConfig: {
                    onChange: this.update_filters,
                    dateFormat: "m/d/Y",
                },
            }
        },
        computed: {
            pageArray () {
                // let pages = Array(this.collection.state.totalPages).fill(1)
                let pages = Array(this.pagination.totalPages).fill(1)
                return pages.map((item, index) => index + 1)
            },
        },
        methods: {
          showPopup(id) {
            try {
              jQuery('#votes-' + id).foundation('open')
            }
            catch (ex) {
              let el = new Foundation.Reveal(jQuery('#votes-' + id));
              jQuery('#votes-' + id).foundation('open')
            }
          },
            isodate (usdate) {
                let parts = usdate.split('/')
                parts.unshift(parts.pop())
                return parts.join('-')
            },
            previous () {
                // let p = this.collection.state.currentPage - 1;
                let p = this.pagination.page - 1
                if (p > 0) {
                    this.get_page(p)
                }

                window.scrollTo(0, 0)
            },
            next () {
                // let p = this.collection.state.currentPage + 1;
                let p = this.pagination.page + 1;
                // if (p <= this.collection.state.totalPages) {
                if (p <= this.pagination.totalPages) {
                    this.get_page(p)
                }

                window.scrollTo(0, 0)
            },
            update_filters () {
                this.get_page(1)
            },
            update_search: _.debounce(async function () { 
              await this.get_page(1)
            }, 400),
            async get_page (page_num, is_link=false) {
                let new_search = false;
                let filters = {
                }
                if (this.params.start_date) {
                    filters.after = this.isodate(this.params.start_date) + 'T00:00:00'
                    new_search = true;
                }
                if (this.params.end_date) {
                    filters.before = this.isodate(this.params.end_date) + 'T11:59:59'
                    new_search = true;
                }
                if (!!this.params.search) {
                    filters.search = this.params.search
                    new_search = true;
                }

                if (is_link) {
                    window.scrollTo(0, 0)
                }

                if (!new_search) {
                  this.items = await this.collection.fetch({
                      data: {
                          page: page_num,
                          per_page: perPage,
                          status: ['publish', 'future'],
                          ...filters,
                      }
                  })

                  this.pagination = {
                    page: page_num,
                    totalPages: this.collection.state.totalPages,
                    totalObjects: this.collection.state.totalObjects,
                  }
                }
                else {
                  let args = {
                    page: page_num,
                    per_page: perPage,
                    status: ['publish', 'future'],
                    ...filters
                  };
                  let sp = new URLSearchParams(args);
                  let res = await fetch('/wp-json/wilmcc/v1/bla-search?' + sp.toString())

                  this.items = await res.json()
                  // this.collection.state.currentPage = page_num
                  // this.collection.state.totalPages = Math.ceil(this.items.length / perPage)
                  this.pagination.page = page_num
                  this.pagination.totalPages = Number(res.headers.get('x-wp-totalpages'))
                  this.pagination.totalObjects = Number(res.headers.get('x-wp-total'))
                }
            },
            
            get_year (year) {
                this.params.start_date = `01/01/${year}`
                this.params.end_date = `12/31/${year}`
                this.update_filters()
            },
        },
        async created () {
            this.collection = new wp.api.collections.Legislation()
            this.items = await this.collection.fetch({
                data: {
                    per_page: perPage,
                    status: ['publish', 'future'],
                }
            })
            this.pagination = {
              page: 1,
              totalPages: this.collection.state.totalPages,
              totalObjects: this.collection.state.totalObjects,
            }
            this.$nextTick(_ => this.loading = false)
        },
        async mounted () {
        }
    }).$mount('#bla-app')
})



// WEBPACK FOOTER //
// ./src/main.js